<template>
  <div class="fibo-page">
    <HeaderNav />
    
    <!-- FIBO Content -->
    <section class="fibo-content">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="fibo-header">
              <h1>FIBO Global Fitness</h1>
              <p>International fitness industry exhibition</p>
            </div>
            
            <div class="fibo-image">
              <img src="/static/images/home_fibo.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/fibox2.png" alt="FIBO" class="img-fluid" ref="lazyImg">
            </div>
            
            <div class="fibo-description">
              <p>FIBO is the world's leading trade show for fitness, wellness and health. It brings together industry professionals, fitness enthusiasts, and innovative companies from around the globe.</p>
              
              <div class="fibo-features">
                <div class="feature-item">
                  <h3>Global Network</h3>
                  <p>Connect with fitness professionals worldwide</p>
                </div>
                
                <div class="feature-item">
                  <h3>Innovation Hub</h3>
                  <p>Discover the latest fitness technologies and trends</p>
                </div>
                
                <div class="feature-item">
                  <h3>Business Opportunities</h3>
                  <p>Explore new partnerships and business ventures</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    
  </div>
</template>

<script>
import HeaderNav from '@/components/HeaderNav.vue'
import { lazyLoadingMixin } from '@/mixins/lazyLoading'

export default {
  mixins: [lazyLoadingMixin],
  name: 'FIBO',
  components: {
    HeaderNav
  },
  mounted() {
    document.title = 'FIBO - ANOVATOR'
  }
}
</script>

<style scoped>
.fibo-page {
  min-height: 100vh;
}

.fibo-content {
  padding: 100px 0;
  background: #f8f9fa;
}

.fibo-header {
  text-align: center;
  margin-bottom: 50px;
}

.fibo-header h1 {
  font-size: 48px;
  font-weight: 700;
  color: #333;
  margin-bottom: 20px;
}

.fibo-header p {
  font-size: 20px;
  color: #666;
}

.fibo-image {
  text-align: center;
  margin-bottom: 50px;
}

.fibo-image img {
  max-width: 100%;
  height: auto;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.fibo-description {
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
}

.fibo-description p {
  font-size: 18px;
  line-height: 1.8;
  color: #555;
  margin-bottom: 40px;
}

.fibo-features {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
  margin-top: 50px;
}

.feature-item {
  background: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.feature-item:hover {
  transform: translateY(-5px);
}

.feature-item h3 {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 15px;
}

.feature-item p {
  font-size: 16px;
  color: #666;
  line-height: 1.6;
}

@media (max-width: 768px) {
  .fibo-header h1 {
    font-size: 36px;
  }
  
  .fibo-content {
    padding: 50px 0;
  }
  
  .fibo-features {
    grid-template-columns: 1fr;
  }
}
</style>
